import ds, { dsc, ___ } from '../utils/daoService/DaoServiceClientES6Adapter'
import ebOrder from "@/api/ebOrder";

const ebOrderTemplate = ds.QEbOrderTemplate.using(dsc)

//模板名称数据源查询
ebOrderTemplate.queryEbOrderTemplateName = function (searchData) {
  return ebOrderTemplate
    .select(ebOrderTemplate.templateName)
    .where(ebOrderTemplate.templateName._like$_(searchData.templateName)
      .and(ebOrderTemplate.templateName.notNull()))
    .paging(searchData.page, searchData.limit)
    .tag('queryEbOrderTemplateName')
    .execute(searchData)
}

//模板启用/禁用
ebOrderTemplate.ebOrderTemplateOnOff = function (searchData) {
  return ebOrderTemplate
    .selective(ebOrderTemplate.isActive)
    .update(searchData)
}

//导出
ebOrderTemplate.ebOrderTemplateExcel = function (searchData) {
  if (searchData.startTime) {
    searchData.startTime = new Date(searchData.startTime)
  }
  if (searchData.endTime) {
    searchData.endTime = new Date(searchData.endTime)
  }
  ds.otherClient
    .withModel(ebOrderTemplate)
    .forExport(ebOrderTemplate.fieldContainer())
    .where(ebOrderTemplate.templateName.eq(':templateName')
      .and(ebOrderTemplate.carrierName.eq(':carrierName'))
      .and(ebOrderTemplate.createTime.gt(':startTime'))
      .and(ebOrderTemplate.createTime.lt(':endTime'))
      .and(ebOrderTemplate.isActive.eq(':isActive')))
    .tag('CTS_WEB_EbOrderTemlateExport')
    .async(false)
    .execute(searchData)
}
////*查询哪张表


//订舱新增页面，在状态旁边增加联想控件“业务类型” --绑定eb_order.biz_type_code 、eb_order.biz_type_name



//2. 联想控件数据来源： 数据字典-代码值为EB_MD_BUSSINESS_TYPE

//联想控件下拉列：业务类型代码 （md_code_dict.code_value）， 业务类型(md_code_dict.display_value_cn)

//前端显示 ：业务类型(md_code_dict.display_value_cn)




//模板名称数据源查询
ebOrderTemplate.queryEbOrderTemplate = function (searchData) {
  if (searchData.startTime) {
    searchData.startTime = new Date(searchData.startTime)
  }
  if (searchData.endTime) {
    searchData.endTime = new Date(searchData.endTime)
  }
  return ebOrderTemplate
    .select(ebOrderTemplate.fieldContainer())
    .where(ebOrderTemplate.templateName.eq(':templateName')
      .and(ebOrderTemplate.carrierName.eq(':carrierName'))
      .and(ebOrderTemplate.createTime.gt(':startTime'))
      .and(ebOrderTemplate.createTime.lt(':endTime'))
      .and(ebOrderTemplate.isActive.eq(':isActive')))
    .paging(searchData.page, searchData.limit)
    .tag('queryEbOrderTemplate')
    .execute(searchData)
}

//根据模板名称数查询
ebOrderTemplate.queryEbOrderTemplateByTemplateName = function (templateName) {
  return ebOrderTemplate
    .select(ebOrderTemplate.fieldContainer())
    .where(ebOrderTemplate.templateName.eq$(templateName))
    .tag('queryEbOrderTemplateByTemplateName')
    .execute()
}

export default ebOrderTemplate
